<table
    [dataSource]="datasource"
    mat-table
    matSort
    #linkedInvoicesSort="matSort">
    <ng-container matColumnDef="file">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            File
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell
            [ngbTooltip]="getExtractionTooltip(linkedFile)"
            [tooltipClass]="'extraction-tooltip'"
            container="body">
            <app-pill-invoice
                *ngIf="!(linkedFile.fileType || '').toLowerCase().includes('uploadeddocument'); else pdfPill"
                [yukiDocumentId]="linkedFile.fileId"></app-pill-invoice>
            <ng-template #pdfPill>
                <app-pill-uploaded-document [uploadedDocumentId]="linkedFile.fileId"></app-pill-uploaded-document>
            </ng-template>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="category">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            Category
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            <ng-container *ngIf="isUploadedDocument(linkedFile); else noCategory">
                <select
                    [ngModel]="getDocumentTypeValue(linkedFile)"
                    (change)="updateProjectFileCategory(linkedFile, $any($event.target).value, $event)"
                    (click)="$event.stopPropagation()"
                    class="editable-cell-input"
                >
                    <option value="">Kies</option>
                    <option *ngFor="let category of projectFileCategories" [value]="category.value">{{ category.label }}</option>
                </select>
            </ng-container>
            <ng-template #noCategory>—</ng-template>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="fileNumber">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            File number
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            <ng-container *ngIf="isUploadedDocument(linkedFile); else noFileNumber">
                {{ linkedFile.extractedFileNumber || '—' }}
            </ng-container>
            <ng-template #noFileNumber>—</ng-template>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="extract">
        <th
            *matHeaderCellDef
            mat-header-cell>
            AI Extract
        </th>
        <td
            *matCellDef="let linkedFile"
            class="td-icon"
            mat-cell>
            <button
                *ngIf="canExtract(linkedFile)"
                (click)="extractProjectDocument(linkedFile, $event)"
                [disabled]="extractingByFileId[linkedFile.fileId]"
                class="button button--icon button--small"
                [ngbTooltip]="'Detecteer en extraheer PO/SES data met AI'"
                style="position: relative;">
                <i *ngIf="!extractingByFileId[linkedFile.fileId]" class="las la-magic"></i>
                <i *ngIf="extractingByFileId[linkedFile.fileId]" class="las la-spinner la-spin"></i>
            </button>
            <span *ngIf="linkedFile.extractionStatus === 'SUCCESS'" style="color: green; margin-left: 4px;" title="Extractie succesvol">✓</span>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="period">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            Period
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            <ng-container *ngIf="isUploadedDocument(linkedFile); else noPeriod">
                <div class="period-edit" (click)="$event.stopPropagation()">
                    <input
                        type="date"
                        class="period-edit__input"
                        [ngModel]="linkedFile.extractedPeriodFrom || ''"
                        (ngModelChange)="updateProjectDocumentPeriod(linkedFile, $event, linkedFile.extractedPeriodTo)"
                        [disabled]="updatingPeriodByFileId[linkedFile.fileId]" />
                    <span class="period-edit__separator">-</span>
                    <input
                        type="date"
                        class="period-edit__input"
                        [ngModel]="linkedFile.extractedPeriodTo || ''"
                        (ngModelChange)="updateProjectDocumentPeriod(linkedFile, linkedFile.extractedPeriodFrom, $event)"
                        [disabled]="updatingPeriodByFileId[linkedFile.fileId]" />
                </div>
            </ng-container>
            <ng-template #noPeriod>—</ng-template>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="amount">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            Allocated amount
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            {{ (linkedFile.folderId === 1 ? -getAllocatedAmount(linkedFile) : getAllocatedAmount(linkedFile)) | currency: 'EUR' }}
            <span
                *ngIf="linkedFile.amount < 0"
                class="badge badge--info m-l-4">
                creditnota
            </span>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell>
            {{ calculateTotal() | currency: 'EUR' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="date">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            Date
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            {{ linkedFile.invoiceDate | date }}
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
        <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header>
            Invoice number
        </th>
        <td
            *matCellDef="let linkedFile"
            mat-cell>
            {{ linkedFile.invoiceNumber }}
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="budgetLink">
        <th
            *matHeaderCellDef
            mat-header-cell>
            Budget
        </th>
        <td
            *matCellDef="let linkedFile"
            class="td-icon"
            mat-cell>
            <button
                (click)="openBudgetLinkModal(linkedFile, $event)"
                class="button button--icon button--small"
                [ngbTooltip]="'Link purchase invoice to budget (project-only)'">
                <i class="las la-wallet"></i>
            </button>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <ng-container matColumnDef="delete">
        <th
            *matHeaderCellDef
            class="td-small"
            mat-header-cell></th>
        <td
            *matCellDef="let linkedFile"
            class="td-icon"
            mat-cell>
            <button
                (click)="$event.stopPropagation(); deleteLink(linkedFile)"
                class="button button--icon button--small">
                <i class="las la-trash color--red"></i>
            </button>
        </td>
        <td
            *matFooterCellDef
            mat-footer-cell></td>
    </ng-container>

    <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row>
    </tr>
    <tr
        (click)="openInvoiceInformationModal(row)"
        *matRowDef="let row; columns: displayedColumns"
        class="pointer"
        mat-row>
    </tr>

    <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length" class="mat-cell">
            <ng-container
                *ngIf="linkedFilesToObjectWithId?.objectId === objectId && linkedFilesToObjectWithId$ | async; else loading">
                There are no files linked to this object...
            </ng-container>
        </td>
    </tr>

    <ng-container *ngIf="showInvoices && linkedFilesToObjectWithId?.linkedFiles?.length > 0">
        <tr
            *matFooterRowDef="displayedColumns"
            mat-footer-row></tr>
    </ng-container>

    <ng-container *ngIf="showFiles">
        <tr
            *matFooterRowDef="['add']"
            mat-footer-row></tr>
    </ng-container>

    <ng-container matColumnDef="add">
        <td
            (click)="openAddDocumentModal()"
            *matFooterCellDef
            class="table-view__add add-document-cell"
            [attr.colspan]="displayedColumns.length"
            mat-footer-cell
        >
            <i class="las la-plus"></i> Add document
        </td>
    </ng-container>
</table>


<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
